// components
import CommonActionModal from "../Common/CommonActionModal";
import BaseApi from "../../utils/BaseApi";
import {deleteArrayItemByKeyValue, setArrayKey, splitToList} from "../../utils/misc";
import CommonForm from "../Common/CommonForm";

// icons
import AddCircleIcon from '@mui/icons-material/AddCircle';
import TableViewIcon from "@mui/icons-material/TableView";


class ChecklistConvertionRuleCreate extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: AddCircleIcon,
            buttonLabel: 'Добавить',
            buttonColor: 'primary',
            ready: true,
        })
    }

    async beforeModalOpen(){
        let formFields = await this.retrieveFields();
        return {
            modalLabel: 'Добавление типа',
            modalIcon: TableViewIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
            },
        }
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        formDataObj.checklist_type = this.props.checklistType.id
        if ('questions' in formDataObj) {
            formDataObj.questions = splitToList(formDataObj.questions, ',')
        }
        const url = `checklist_convertion_rule/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formDataObj
        );
        if (response.status === 201) {
            if (typeof this.props.callBack == 'function') {
                await this.props.callBack();
                this.setModalOpenFalse();
            }
        }
        return response
    }

    async retrieveChecklistTypeQuestions() {
        const api = new BaseApi();
        let url = 'checklist_type_question/';
        let params = {
            page_size: 10000,
            type: this.props.checklistType.id
        }
        let response = await api.get(url, params);
        return response.data.results
    }

    async retrieveFields(){
        const url = `checklist_convertion_rule/create_form/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        let formFields = response.data
        formFields = deleteArrayItemByKeyValue(
            formFields,
            'name',
            'checklist_type'
        );
        let questions = await this.retrieveChecklistTypeQuestions()
        formFields = setArrayKey(
            formFields,
            'name',
            'questions',
            'options',
            questions.map((each) => (
                {'value': each.question.id, 'label': each.question.title,}
            ))
        );
        return formFields
    }
}

export default ChecklistConvertionRuleCreate
